export var errors = {
    unauthorized: new Error('airbrake: unauthorized: project id or key are wrong'),
    ipRateLimited: new Error('airbrake: IP is rate limited'),
};
//# sourceMappingURL=api.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@airbrake/browser/esm/http_req/api.js
// module id = 200
// module chunks = 0